import { authRequest } from '../../../core/api/authApiClient'; // 혹은 별도의 userApiClient가 있다면 그것을 사용
import type { UserRepository } from '../Domain/repository/UserRepository';
import type { 
  UserProfile, 
  UpdateUserRequest, 
  UpdateUserResponse, 
  PatchUserRequest, 
  PatchUserResponse,
  SearchUsersRequest,
  SearchUsersResponse,
  CreateUserRequest,
  CreateUserResponse,
  GetUserRequest,
  GetUserResponse
} from '../Domain/entity/UserTypes';

export class UserRepositoryImpl implements UserRepository {
  async getUserDetails(userId: string): Promise<UserProfile> {
    // /sp/users 엔드포인트 호출
    return authRequest<UserProfile>('/sp/users', {
      body: { user_id: userId },
    });
  }
  
  async updateUser(request: UpdateUserRequest): Promise<UpdateUserResponse> {
    // PUT /users/put 엔드포인트 호출
    return authRequest<UpdateUserResponse>('/users/put', {
      method: 'POST', // API Gateway에서 PUT을 POST로 처리할 수 있음
      body: request,
    });
  }
  
  async patchUser(request: PatchUserRequest): Promise<PatchUserResponse> {
    // PATCH /users/patch 엔드포인트 호출
    return authRequest<PatchUserResponse>('/users/patch', {
      method: 'POST', // API Gateway에서 PATCH를 POST로 처리
      body: request,
    });
  }
  
  async searchUsers(request: SearchUsersRequest): Promise<SearchUsersResponse> {
    // POST /users/m/sch 엔드포인트 호출
    return authRequest<SearchUsersResponse>('/users/m/sch', {
      method: 'POST',
      body: request,
    });
  }
  
  async createUser(request: CreateUserRequest): Promise<CreateUserResponse> {
    // POST /users 엔드포인트 호출
    return authRequest<CreateUserResponse>('/users', {
      method: 'POST',
      body: request,
    });
  }
  
  async getUser(request: GetUserRequest): Promise<GetUserResponse> {
    // POST /users/get 엔드포인트 호출
    return authRequest<GetUserResponse>('/users/get', {
      method: 'POST',
      body: request,
    });
  }
}

